import { useEffect, useState } from "react";
import { adminGetServices, adminPutService } from "@/lib/api";
import { Check } from "lucide-react";

export default function AdminServices() {
  const [items, setItems] = useState([]);
  const [saved, setSaved] = useState("");
  const load = () => adminGetServices().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = (idx, field, val) => { const n = [...items]; n[idx] = { ...n[idx], [field]: val }; setItems(n); };
  const save = async (s) => {
    await adminPutService({ slug: s.slug, name: s.name, description: s.description, price_label: s.price_label, tier_order: Number(s.tier_order) });
    setSaved(s.slug); setTimeout(() => setSaved(""), 2000);
  };

  return (
    <div data-testid="admin-services">
      <p className="cv-kicker">Services</p>
      <h1 className="cv-display text-3xl mt-4">The ladder.</h1>
      <p className="cv-body text-sm text-[#9A938A] mt-3 max-w-xl">Price labels are display text only. The Stripe charge is fixed in code and cannot be edited here.</p>
      <div className="mt-8 space-y-5 max-w-2xl">
        {items.map((s, idx) => (
          <div key={s.slug} data-testid="admin-service-row" className="border border-[rgba(28,27,25,0.14)] rounded-[14px] p-5">
            <div className="flex gap-3">
              <input className="cv-input flex-1" value={s.name} onChange={(e) => update(idx, "name", e.target.value)} />
              <input className="cv-input w-20" type="number" value={s.tier_order} onChange={(e) => update(idx, "tier_order", e.target.value)} />
            </div>
            <textarea rows={3} className="cv-input mt-3 resize-none" value={s.description} onChange={(e) => update(idx, "description", e.target.value)} />
            <input data-testid="admin-service-price-label" className="cv-input mt-3" value={s.price_label} onChange={(e) => update(idx, "price_label", e.target.value)} placeholder="Price label (display only)" />
            <div className="flex items-center gap-3 mt-3">
              <button data-testid="admin-service-save" className="cv-btn-secondary" onClick={() => save(s)}>Save</button>
              {saved === s.slug && <span className="cv-body text-xs text-[#515E4F] inline-flex items-center gap-1"><Check size={13} /> Saved</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
